module.exports = __webpack_public_path__ + "static/media/alarm_on.7e6bb2c9.png";